import { clsx } from "clsx";

export default function Block(props: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx("py-18", props.className ? props.className : "")}>
      {props.children}
    </div>
  );
}
